import React, { useMemo, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Img, svgSprite } from '../../../../../hybrid/wrappers';
import MenuOfficeItem from '../MenuOfficeItem/MenuOfficeItem';
import UserContext, { StoreContext, UserProfileContext } from '../../../../../common/utils/getContext';
import { generateActives, getItemMenu } from '../../../helpers';
import { useRouter } from 'next/router';
import RegionAndCurrencySwitcher from '../../../../regionAndCurrencySwitcher/RegionAndCurrencySwitcher/RegionAndCurrencySwitcher';
import { useUnscrollableBody } from '../../../../../common/utils/windowDimensions';
import MobMenu from '../../../../../hybrid/library/MobMenu/MobMenu';
import css from './MenuOffice.module.scss';
import classnames from 'classnames';
import { addedMenuItems } from '../../../../../common/utils/utils';
import T from '../../../../../common/components/T';
import { navigateV2 } from '../../../../../common/utils/router';

const MenuOffice = ({ mainMenu, toggleMenu, active }) => {
    const { roles = [], profileData } = useContext(UserProfileContext) || {};
    const { categories = [] } = useContext(StoreContext) || {};

    const [submenu, setSubmenu] = useState(false);
    const [showCategories, setShowCategories] = useState(false);
    const { lang, menu, userToken } = useContext(UserContext);
    const newOfficeItems = useMemo(() => addedMenuItems(profileData), [profileData]);
    const officeMenu = useMemo(() => [...(menu?.site || []), ...(newOfficeItems?.site || [])], [newOfficeItems, menu?.site]);

    const itemMenu = useMemo(() => getItemMenu(officeMenu, roles, lang, !!userToken), [roles, officeMenu, lang, userToken]);
    const router = useRouter();
    const activeItems = useMemo(() => generateActives(itemMenu, router, active), [itemMenu, router, active]);
    useUnscrollableBody(mainMenu, 'MenuOffice');

    return (
        <>
            <MobMenu expanded={mainMenu} removeMenu={() => toggleMenu()} compStyles={css}>
                <div className={classnames(css.officeMenuTitle, { [css.officeMenuTitleWithoutBorder]: showCategories })}>
                    <div onClick={() => toggleMenu()} className={classnames('circleButton', css.officeMenuClose)}>
                        {svgSprite('cross', {
                            width: '20px',
                            height: '20px'
                        })}
                    </div>
                    {/* <p className={css.officeMenuTitleP}>
                        <T textName='menu' defaultStr='Меню' page='/office' />
                    </p> */}
                    <div>
                        <RegionAndCurrencySwitcher mode={'left'} compStyle={{ wrapper: css.officeMenuTitleSwitcher }} />
                    </div>
                </div>
                <div className={classnames('scrollbar-hidden', css.officeMenuScroll)}>
                    <div className={css.officeMenuWrapper}>
                        <div
                            onClick={() => setShowCategories((s) => !s)}
                            className={classnames(css.menuCategories, {
                                [css.dn]: !categories || !categories?.length,
                                [css.menuCategoriesOpened]: showCategories
                            })}
                        >
                            <div className={css.menuCategoriesLeft}>
                                <div
                                    className={classnames(css.menuCategoriesIcon, {
                                        [css.menuCategoriesIconRotate]: showCategories
                                    })}
                                >
                                    {svgSprite(showCategories ? 'angle-right-system' : 'bag')}
                                </div>
                                <p className={css.menuCategoriesTitle}>
                                    <T textName='product_categories' defaultStr='Категории товаров' />
                                </p>
                            </div>
                            <div className={classnames(css.menuCategoriesRight, { [css.dn]: showCategories })}>
                                {svgSprite('angle-right-system')}
                            </div>
                        </div>
                        <div className={classnames(css.menuCategoriesList, { [css.dn]: !showCategories })}>
                            {categories?.map((category) => (
                                <div
                                    onClick={() => navigateV2(`/store/category/${category?.url}`)}
                                    key={category.id}
                                    className={css.menuCategoriesLi}
                                >
                                    <div className={css.menuCategoriesLiCircle}>
                                        {category?.image?.links?.preview ? (
                                            <Img src={category?.image?.links?.preview} />
                                        ) : (
                                            svgSprite('product-no-image')
                                        )}
                                    </div>
                                    <p className={css.menuCategoriesLiTitle}>{category.name}</p>
                                </div>
                            ))}
                        </div>
                        {itemMenu &&
                            !showCategories &&
                            itemMenu.map((menuItem, idx) => (
                                <MenuOfficeItem
                                    toggleMenu={toggleMenu}
                                    menuItem={menuItem}
                                    submenu={submenu}
                                    active={activeItems}
                                    setSubmenu={setSubmenu}
                                    key={`menuItem${idx}`}
                                    isLast={idx === itemMenu.length - 1}
                                />
                            ))}
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    {/* {windowDimensions <= 992 && <LangSwitcher single={false} />}
                    {windowDimensions > 767 && <RegionAndCurrencySwitcher />} */}
                </div>
                {/* <AppButtons /> */}
                {/* <div className={css.officeMenuFooter}>
                    <p className={css.officeMenuFooterText}>
                        <T
                            textName='copyright'
                            vars={{
                                year: currentYear,
                                company: project?.company
                            }}
                            defaultStr='Copyright © ${year} ${company}. All rights reserved'
                            page='all'
                        />
                    </p>
                    <p className={css.menuFooterText}>
                        <T textName='devText' defaultStr='Разработка' page='all' />
                        {' — '}
                        <A className={css.cursorPointer} href={project?.developer?.link}>
                            {project?.developer?.text}
                        </A>
                    </p>
                </div> */}
            </MobMenu>
        </>
    );
};
MenuOffice.propTypes = {
    mainMenu: PropTypes.bool,
    toggleMenu: PropTypes.func,
    submenu: PropTypes.object,
    active: PropTypes.string,
    setSubmenu: PropTypes.func
};
export default MenuOffice;
